import * as React from "react";
import CounterBadge from "./CounterBadge";
const SecurityEventsCount = ({ events }) => /* @__PURE__ */ React.createElement(CounterBadge, { count: events, singular: "Event", plural: "Events" });
export default SecurityEventsCount;
